import { memo } from 'react';
import ReactQuill from 'react-quill';

import './texteditor.css';

const defaultModules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{ 'color': [] }, { 'background': [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
    ],
    ['link'],
    ['clean'],
  ],
};

function RichTextEditor({ value, onChange, modules, readOnly }) {
  function handleChange(content, delta, source, editor) {
    // Only persist genuine user edits. Quill rewrites non-canonical HTML into its
    // own form on mount and reports it as a change with source 'api'; propagating
    // that would mark the field dirty and re-save a description the user never
    // touched (e.g. turning `<br><br>` into a blank-line paragraph).
    if (source !== 'user') return;

    // getText() omits embeds, so an embed-only edit (e.g. a pasted image) has
    // whitespace-only text. Only treat the document as empty when it also has no
    // embeds, otherwise clearing here would drop the embed the user just added.
    const hasEmbed = editor.getContents().ops.some((op) => typeof op.insert === 'object');
    if (!hasEmbed && editor.getText().trim().length === 0) {
      onChange('');
      return;
    }

    onChange(content);
  }

  return (
    <ReactQuill
      theme="snow"
      readOnly={readOnly}
      modules={modules || defaultModules}
      value={value}
      onChange={handleChange}
    />
  );
}

// Memoized so a parent re-render (e.g. editing another field) doesn't re-render
// the editor when value/onChange/modules are unchanged. Without this, react-quill
// re-applies the value on every render, which re-parses non-canonical HTML and can
// disturb the cursor.
export default memo(RichTextEditor);
